export const environment = {
  production: false,
  defaultauth: 'firebase',
  firebaseConfig: {
    apiKey: 'AIzaSyBP45D-N9f8pREc1M7aBPMNwhRns1LoATg',
    authDomain: 'cuality-ef92f.firebaseapp.com',
    projectId: 'cuality-ef92f',
    storageBucket: 'cuality-ef92f.appspot.com',
    messagingSenderId: '337677129033',
    appId: '1:337677129033:web:92eff84e611cfab1243698',
    measurementId: 'G-94J85D16CJ',
  },
};
